<ng-container *ngIf="!showCustom404; else notFound">
    <div class="w-full bg-white p-5">
        <div class="mx-auto max-w-6xl">
            <div class="mb-5 flex md:gap-7">
                <div class="relative">
                    <div class="sticky top-20 hidden flex-col gap-3 md:flex">
                        <button (click)="shareFacebook()">
                            <img
                                alt="facebook.png"
                                class="h-8 w-8 cursor-pointer"
                                ngSrc="/assets/images/logo/facebook.png"
                                height="32"
                                width="32"
                            />
                        </button>
                        <button (click)="shareLinkedin()">
                            <img
                                alt="linkedin.png"
                                class="h-8 w-8 cursor-pointer"
                                ngSrc="/assets/images/logo/linkedin.png"
                                height="32"
                                width="32"
                            />
                        </button>
                        <button (click)="copyClipboard()">
                            <img
                                *ngIf="!showCheck"
                                alt="copy_link.png"
                                class="h-8 w-8"
                                ngSrc="/assets/images/logo/copy_link.png"
                                height="32"
                                width="32"
                            />
                            <mat-icon
                                *ngIf="showCheck"
                                class="h-8 w-8 text-green-700"
                                svgIcon="feather:check"
                            />
                        </button>
                    </div>
                </div>
                <div class="flex-1">
                    <h1
                        class="text-3xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl"
                    >
                        {{ article?.nom }}
                    </h1>
                    <span class="text-black-500 whitespace-nowrap">
                        {{ ThemeArticle[article?.themeArticle] }}
                    </span>
                    <div *ngIf="article?.image">
                        <app-image
                            [imageClass]="'mt-5 w-full rounded-lg object-cover'"
                            [showIfNotLoaded]="false"
                            [imageSrc]="cloud_front + article?.image"
                        />
                    </div>
                    <div
                        (click)="redirectionProfil(user.userId)"
                        class="my-3 flex cursor-pointer items-center gap-4 border-y border-black p-2"
                    >
                        <img
                            *ngIf="user?.urlPhotoProfil"
                            alt="profile"
                            class="h-13 w-13 rounded-full object-cover"
                            [ngSrc]="cloud_front + user?.urlPhotoProfil"
                            height="52"
                            width="52"
                        />
                        <div class="flex flex-col text-lg">
                            <span class="font-bold capitalize">{{
                                user?.userName
                            }}</span>
                            <span class="font-light">
                                {{
                                    article?.date | date: 'MMM d, yyyy, h:mm a'
                                }}
                            </span>
                        </div>
                    </div>
                    <div class="my-5 w-full" [innerHTML]="html"></div>
                </div>
                <div class="relative">
                    <app-stats-cards class="sticky top-20 hidden md:flex" />
                </div>
            </div>
          <!--   <aside aria-label="Articles recommandés" class="mt-12 w-full">
                <app-recommendation-article
                [listeMedias]="articlesRecommendes"
                type="ARTICLES"
            />
        </aside> -->

        </div>
    </div>
    <!-- <app-newsletter
        [theme]="article?.themeArticle"
        [actif]="article?.actif"
        type="ARTICLE"
    /> -->
    <div
        (click)="hideSocials()"
        *ngIf="showSocials"
        class="fixed inset-0 z-49 bg-black bg-opacity-25 md:hidden"
    ></div>
    <div
        *ngIf="showSocials"
        class="fixed bottom-22 right-4 z-49 flex w-[calc(100%-2rem)] max-w-96 flex-col border-2 bg-white md:hidden"
    >
        <button
            class="flex items-center gap-2 border p-2"
            (click)="shareFacebook()"
        >
            <img
                class="h-5 w-5"
                alt="facebook.png"
                ngSrc="/assets/images/logo/facebook.png"
                height="20"
                width="20"
            />
            <span>Partager sur facebook</span>
        </button>
        <button
            class="flex items-center gap-2 border p-2"
            (click)="shareLinkedin()"
        >
            <img
                class="h-5 w-5"
                alt="linkedin.png"
                ngSrc="/assets/images/logo/linkedin.png"
                height="20"
                width="20"
            />
            <span>Partager sur Linkedin</span>
        </button>
        <button
            [ngClass]="{
                'bg-green-50': showCheck,
                'flex items-center gap-2 border p-2': true,
            }"
            (click)="copyClipboard()"
        >
            <img
                *ngIf="!showCheck"
                class="h-5 w-5"
                alt="copy_link.png"
                ngSrc="/assets/images/logo/copy_link.png"
                height="20"
                width="20"
            />
            <mat-icon
                *ngIf="showCheck"
                class="h-5 min-h-5 w-5 min-w-5 text-green-700"
                svgIcon="feather:check"
            />
            <span>{{ showCheck ? 'Lien copié' : 'Copier ce lien' }}</span>
        </button>
    </div>
    <button
        (click)="toggleShowSocials()"
        class="fixed bottom-4 right-4 z-49 flex h-16 w-16 items-center justify-center rounded-full bg-blue-800 shadow md:hidden"
    >
        <mat-icon class="h-8 w-8 text-white" svgIcon="heroicons_solid:share" />
    </button>
</ng-container>
<ng-template #notFound>
    <div class="not-found-container">
        <div
            class="mx-auto flex min-h-[60vh] max-w-[600px] flex-col items-center justify-center px-4 py-8"
        >
            <!-- 404 Title -->
            <h1 class="mb-4 text-6xl font-bold text-gray-400">404</h1>

            <!-- Message -->
            <div
                class="text-secondary mt-2 text-center text-lg font-medium tracking-tight text-gray-600 md:text-xl"
            >
                Nous sommes désolés, mais l'article ou la page que vous
                recherchez n'existe pas ou le lien est incorrect.
            </div>
            <button
            routerLink="/actualites"
            class="mt-12 max w-50 p-2 rounded-lg font-medium bg-primary-500 text-[white]">
         
                Revenir à la page d'acceuil
        </button>
        </div>
    </div>
</ng-template>
